import React from 'react';
import { useSaveAutomationDraft } from 'pages/Automations/hooks';
import { Modal, ModalBody, ModalFooterButtons, ModalHeader, ModalCloseButton } from '@televet/kibble-ui';

interface ActivateAutomationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ActivateAutomationModal = ({ isOpen, onClose }: ActivateAutomationModalProps): JSX.Element => {
  const { saveAutomationDraft, isSaving } = useSaveAutomationDraft();

  const handleActivateButtonClick = async (): Promise<void> => {
    await saveAutomationDraft({ isPublished: true });
    onClose();
  };

  return (
    <Modal size="md" onClose={onClose} isOpen={isOpen}>
      <ModalHeader>Your automation has unsaved changes</ModalHeader>
      <ModalCloseButton />
      <ModalBody>Are you sure you are ready to save these changes and activate this automation?</ModalBody>
      <ModalFooterButtons isLoading={isSaving} onSubmit={handleActivateButtonClick} submitText="Save and Activate" />
    </Modal>
  );
};
